var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCheck(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#E9F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.582 10.45l-8.149 8.148a1.361 1.361 0 101.926 1.925l8.148-8.148a1.361 1.361 0 10-1.925-1.925z",
    fill: "#41AAAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.967 16.084l4.441 4.442a1.361 1.361 0 101.926-1.926L9.892 14.16a1.362 1.362 0 00-1.925 1.925z",
    fill: "#41AAAF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCheck);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/uploadCheck.f4d13d54.svg";
export { MemoForwardRef as ReactComponent };